import React from "react";
import "./pill.scss";
import classNames from "classnames";
import { GLOBAL_LINK_NO_TX_CLASS } from "utilities/globalLinkNoTx";
import { ReactComponent as UserIcon } from "assets/images/user-icon.svg";
import { ReactComponent as TaskNoteCautionIcon } from "assets/images/v2/task-note-caution-icon.svg";

interface PillProps {
  text: string;
  variant?: "assigned" | "comments" | "invalid";
}

const Pill: React.FC<PillProps> = ({ text, variant = "assigned" }) => {
 
  let containerClass = "pill-container";

  switch (variant) {
    case "comments":
      containerClass += " pill-container--comments";
      break;
    case "invalid":
      containerClass += " pill-container--invalid";
      break;
    default:
      break;
  }
  const iconClass = variant === "comments" ? "pill-icon pill-icon--warning" : "pill-icon";
  
  let textClass = "pill-text";

  switch (variant) {
    case "comments":
      textClass += " pill-text--comments";
      break;
    case "invalid":
      textClass += " pill-text--invalid";
      break;
    default:
      break;
  }

  const renderIcon = () => {
  switch (variant) {
    case "comments":
      return <TaskNoteCautionIcon className={iconClass} />;

    case "assigned":
      return <UserIcon className={iconClass} />;

    case "invalid":
      return <TaskNoteCautionIcon className={iconClass} />;

    default:
      return null;
  }
};


  return (
    <div className={containerClass}>
      {renderIcon()}
      <span className={classNames(textClass, variant === "assigned" && GLOBAL_LINK_NO_TX_CLASS)} data-testid="assigned-to-pill">
        {text}
      </span>
    </div>
  );
};

export default Pill;
